export default {
  title: 'Get Started',
  description: 'In order to load the current page, you must complete the Get Started guide',
  button: 'Get Started',
};
